import { StandardEvents } from '@shopify/events';

document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  const root = event.target instanceof Element && event.target.closest('[data-soyul-product]');
  if (!root || event.action !== 'add' || !event.promise) return;
  const state = busy => root.dispatchEvent(new CustomEvent('soyul:purchase-state', {detail:{busy}}));
  let messageTimer;
  const message = (text, transient = false) => {
    clearTimeout(messageTimer);
    root.querySelectorAll('[data-soyul-purchase-status]').forEach(el => {
    el.textContent = text;
    el.hidden = !text;
    });
    if (text && transient) messageTimer = setTimeout(() => message(''), 3600);
  };
  state(true); message('');
  event.promise.then(({detail}) => {
    if (detail?.didError) message('L’ajout n’a pas abouti. Vérifiez cette taille et réessayez.');
    else message('Ajouté au panier ✓', true);
  }).catch(() => {
    message('Impossible de confirmer l’ajout. Vérifiez votre connexion et le contenu du panier avant de réessayer.');
  }).finally(() => state(false));
});
